import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../../services/auth.service';
import { CryptoService } from '../../../../services/crypto.service';
import { FormBankComponent } from 'src/app/vtuber/support/forms/bank/bank.component';

@Component({
  selector: 'app-vtuber-bank-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss']
})
export class VTuberBankEditComponent implements OnInit {
  bankForm: any = {
    bank_name: '',
    branch_code: '',
    account_type: FormBankComponent.ACCOUNT_TYPE_NORMAL,
    account_number: '',
    account_name: ''
  }

  constructor(
    public auth: AuthService,
    private crypto: CryptoService
  ) {}

  ngOnInit() {
    this.bankForm = this.auth.user.bank ? this.auth.user.bank : {
      bank_name: '',
      branch_code: '',
      account_type: FormBankComponent.ACCOUNT_TYPE_NORMAL,
      account_number: '',
      account_name: ''
    }

    this.bankForm.account_name = this.crypto.decrypt(this.bankForm.account_name)
    this.bankForm.account_number = this.crypto.decrypt(this.bankForm.account_number)
    this.bankForm.account_type = this.crypto.decrypt(this.bankForm.account_type)
    this.bankForm.bank_name = this.crypto.decrypt(this.bankForm.bank_name)
    this.bankForm.branch_code = this.crypto.decrypt(this.bankForm.branch_code)
  }

}
